import { Component, OnInit } from "@angular/core";
import { PrimeIcons } from "primeng/api";
import { Product } from "../models/product";
import { PropertyService } from "app/services/property.service";
import { ActivatedRoute } from "@angular/router";
import { Property } from "app/models/property.model";

@Component({
  selector: "app-buildings-detail",
  templateUrl: "./buildings-detail.component.html",
  styleUrls: ["./buildings-detail.component.scss"],
})
export class BuildingsDetailComponent implements OnInit {
  images: any[] | undefined;
  loadingProperties = true;
  loadingProperty = true;
  property: Property;
  uuid: string;
  products: Product[] | undefined;
  propertyList: any[] = [];
  parsedDescription: any;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  constructor(
    private readonly propertyService: PropertyService,
    private readonly route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.uuid = params.uuid;
      this.loadProperty();
      this.propertyService.getProperties().then((res) => {
        this.propertyList = res;
      }).finally(() => {
        this.loadingProperties = false;
      });
    });

  }

  loadProperty(): void {
    this.propertyService.getPropertyByUuid(this.uuid).then((res) => {
      this.property = res;
      var div = document.getElementById('parsedDescriptionId');
      div.innerHTML += this.property.description;
    }).finally(() => {
      this.loadingProperty = false;
    });
  }

}
